
export function isSameTeam(team1,team2){
  if(!(team1 && team2) || team1.length !== team2.length) return false
  const t1 = team1.map(_p => _p.name || _p)
  const t2 = team2.map(_p => _p.name || _p)
  return t1.filter(_playerName => t2.includes(_playerName)).length === team1.length
}

export default {
  methods:{
    isSameTeam
  }
}